module.exports = __webpack_public_path__ + "static/media/Perc2.a08f7b56.wav";